export const translateSelectionIntoColumnHeading = (
  headings,
  values,
  selectionValueAsString
) => {
  /*  The array-length of both headings and values values.
  Also, the 'selection' value is a string, so convert that.
*/
  const selection = parseInt(selectionValueAsString);

  const index = values.indexOf(selection);
  if (index < 0) {
    alert(
      "translateSelectionIntoColumnHeading: Failed to find index for:" +
        selectionValueAsString
    );
    return null;
  }
  return index;
};

/*
 * getValuesForHeadings
 *
 * Different questions have different number of answer choices ("headings");
 * Let's "spread" the 0-5 values across whatever number-of-choices and
 * return a parallel array for the call to use.
 */
export const getValuesForHeadings = (headings) => {
  let values = [0];
  switch (headings.length) {
    case 1:
      values = [0];
      break;
    case 2: // "boolean" no/yes case
      values = [0, 5];
      break;
    case 3:
      values = [0, 2, 5];
      break;
    case 4:
      values = [0, 2, 4, 5];
      break;
    case 5:
      values = [0, 1, 2, 3, 4];
      break;
    case 6: // "normal" case
      values = [0, 1, 2, 3, 4, 5];
      break;
    default:
      return headings;
  }
  return values;
};

export const isDemographicQuestion = (question) => {
  const demographicList = [
    "gender",
    "size",
    "packs",
    "drinks",
    "age",
    "height",
    "weight",
    "waist",
    "race",
    "concern",
    "text",
  ];
  return demographicList.includes(question.AnswerList);
};

function handleDemographicColumnHeadings(question) {
  let headings = [];
  switch (question.AnswerList) {
    case "text":
      headings = ["Enter text"];
      break;
    case "concern":
      headings = [
        "Chronic Pain",
        "Chronic Fatigue",
        "Mental Health",
        "Hormone Imbalance",
        // "test",
        "Other -- Please describe below",
      ];
      break;
    case "gender":
      headings = ["Male", "Female"];
      break;
    case "size":
      // This one isn't used...
      headings = [
        "Tiny",
        "Very small",
        "Small",
        "Average",
        "Bigger",
        "Much bigger",
      ];
      break;
    case "packs":
      headings = [
        "None/never",
        "Many years ago",
        "Occasional",
        "1/2 pack daily",
        "Pack daily",
        "More",
      ];
      break;
    case "drinks":
      headings = [
        "None/never",
        "Many years ago",
        "Occasional",
        "1 drink/day",
        "2 drinks/day",
        "2+ drinks/day",
      ];
      break;
    case "age":
      headings = ["12-19", "20-39", "40-49", "50-59", "60-69", "70+"];
      break;
    case "weight":
      headings.push("-- Select --");
      for (let weight = 80; weight <= 300; weight += 1)
        headings.push(
          "" + weight + " lbs  (" + (weight / 2.205).toFixed(0) + " kg)"
        );
      break;
    case "height":
      headings.push("-- Select --");
      for (let feet = 4; feet < 8; feet++) {
        for (let inches = 0; inches < 12; inches += 1) {
          const cm = (feet * 12 + inches) * 2.54;
          headings.push(
            "" + feet + "' " + inches + '"   (' + cm.toFixed(0) + " cm)"
          );
        }
      }
      break;
    case "race":
      headings.push("-- Select --"); // Why? Because if the user IS white and it defaults to white then the Select
      // element will not receive a 'change' and we wont go thru the processing
      headings.push("White");
      headings.push("American Indian or Alaska Native");
      headings.push("Asian");
      headings.push("Black or African American");
      headings.push("Hispanic or Latino");
      headings.push("Native Hawaiian/Pacific Islander");
      headings.push("- Choose not to answer -");
      break;
    case "waist":
      headings.push("-- Select --");
      for (let waist = 16; waist < 60; waist++)
        headings.push(
          "" + waist + " inches (" + (waist * 2.54).toFixed(0) + " cm)"
        );
      break;
    default:
      alert("Unknown demographic answerList:" + question.AnswerList);
  }
  return headings;
}

export const getColumnHeadings = (question) => {
  if (isDemographicQuestion(question))
    return handleDemographicColumnHeadings(question);

  let headings = [
    "Not at all/ Unsure",
    "Very rarely",
    "Minimally",
    "Moderately",
    "Significantly",
    "Severely",
  ];

  if (question.AnswerList) {
    switch (question.AnswerList) {
      case "noyes":
        headings = ["No", "Yes"];
        break;
      case "Not at all/Unsure, very minimally, mildly, moderately, significantly, severely": // New file!
        headings = [
          "Not at all/ Unsure",
          "Very minimally",
          "Mildly",
          "Moderately",
          "Significantly",
          "Severely",
        ];
        break;
      case "Not at all/Unsure, very minimal, mild, moderate, significant, severe":
        headings = [
          "Not at all/Unsure",
          "Very minimal",
          "Mild",
          "Moderate",
          "Significant",
          "Severe",
        ];
        break;
      case "Not at all/Unsure, very rarely, minimally, moderately, significantly, severly":
        headings = [
          "Not at all/Unsure",
          "Very rarely",
          "Minimally",
          "Moderately",
          "Significantly",
          "Severly",
        ];
        break;
      case "normal":
        break;
      case "Never/Unsure, Rarely, Sometimes, Often, Very Often, All the time":
      case "Never/Unsure, Rarely, Sometimes, Often, Very Often, Consistently":
        headings = [
          "Never/Unsure",
          "Rarely",
          "Sometimes",
          "Often",
          "Very often",
          "All the time",
        ];
        break;
      case "threeoption":
        headings = ["No", "Once", "Many & Recurrent"];
        break;
      case "range0-8":
        headings = ["None", "1-2", "3-4", "5-6", "7-8", "8+"];
        break;
      case "concerninfo":
      case "extrainfo":
        headings = ["Enter text"];
        break;
      default:
        alert("Unknown answer format detected:" + question.AnswerList);
        console.log("Unknown answer format!", question);
    }
  }
  return headings;
};

/*
 * Each page of questions, we sometimes want to know if ALL of the questions
 * have had a response by the user. This function takes the question array
 * and then another array of which indexes of the question array are used
 * on a particular view/screen.  Then we can run through those questions-of-interest
 * and see if they all have been answered (selection) or not.
 */
export const checkAllSelected = (questions) => {
  for (let i = 0; i < questions.length; i++) {
    if (questions[i].isMetadata) continue;
    if (questions[i].selection === undefined) {
      if (
        questions[i].question.indexOf("Any other health") === -1 &&
        questions[i].question.indexOf("other area of concern") === -1
      ) {
        // HACK! Dont require this special demographic questions
        if (questions[i].required) return i;
      }
    }
  }
  return -1;
};
